import React from 'react';
import { Helmet } from 'react-helmet';
import Form from '../childrens/form/index';

class PreviaNota extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            isError: false,
        };
    }

    render() {
        return (
            <>
                <Helmet>
                    <title>{`${process.env.REACT_APP_TITLE} - Prévia Nota`}</title>
                </Helmet>
                <Form {...this}/>
            </>
        );
    }

};

export default PreviaNota;